import lazyLoad from "@loadable/component";
import createPlugin from "./createPlugin";

import MenuItemsCarouselRenderer from "./Renderer";
const MenuItemsCarouselForm = lazyLoad(() => import("./Form"));

const menuItemsCarouselPlugin = (settings) =>
    createPlugin({
        Renderer: MenuItemsCarouselRenderer,
        Controls: MenuItemsCarouselForm,
        ...settings,
    });

const menuItemsCarousel = menuItemsCarouselPlugin();
export default menuItemsCarousel;

export { menuItemsCarouselPlugin, MenuItemsCarouselRenderer };
